// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var WebComponents_Header = require("./WebComponents_Header.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var WebTypes_PostAShift_Step = require("../types/WebTypes_PostAShift_Step.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingRight(BrowserStyle.zero),
      tl: /* [] */0
    });

var highlightKeyframes = Curry._1(BrowserStyle.keyframes, {
      hd: [
        0,
        {
          hd: BrowserStyle.backgroundColor({
                TAG: /* Blue */0,
                _0: /* Darkest */0
              }),
          tl: /* [] */0
        }
      ],
      tl: {
        hd: [
          50,
          {
            hd: BrowserStyle.backgroundColor({
                  TAG: /* Teal */6,
                  _0: /* Medium */2
                }),
            tl: /* [] */0
          }
        ],
        tl: {
          hd: [
            100,
            {
              hd: BrowserStyle.backgroundColor({
                    TAG: /* Blue */0,
                    _0: /* Darkest */0
                  }),
              tl: /* [] */0
            }
          ],
          tl: /* [] */0
        }
      }
    });

function progressContainer(status) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._1(BrowserStyle.style, {
                    hd: BrowserStyle.alignItems("center"),
                    tl: {
                      hd: BrowserStyle.borderBottomColor(status !== 1 ? /* Transparent */2 : ({
                                TAG: /* Teal */6,
                                _0: /* Medium */2
                              })),
                      tl: {
                        hd: BrowserStyle.borderBottomWidth(status !== 1 ? BrowserStyle.zero : BrowserStyle.rem(0.25)),
                        tl: {
                          hd: BrowserStyle.borderBottomStyle(BrowserStyle.solid),
                          tl: {
                            hd: BrowserStyle.display("flex"),
                            tl: {
                              hd: BrowserStyle.flex({
                                    NAME: "num",
                                    VAL: 1.0
                                  }),
                              tl: {
                                hd: BrowserStyle.flexBasis(BrowserStyle.zero),
                                tl: {
                                  hd: BrowserStyle.justifyContent("center"),
                                  tl: {
                                    hd: BrowserStyle.position("relative"),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }),
              tl: {
                hd: status !== 1 ? "" : Curry._1(BrowserStyle.style, {
                        hd: BrowserStyle.animation(750, 0, undefined, BrowserStyle.easeInOut, undefined, undefined, undefined, highlightKeyframes),
                        tl: /* [] */0
                      }),
                tl: /* [] */0
              }
            });
}

var progressWrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: /* [] */0
      }
    });

var cancelContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.width(BrowserStyle.rem(3.5)),
      tl: {
        hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
        tl: {
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.justifyContent("center"),
            tl: {
              hd: BrowserStyle.alignItems("center"),
              tl: {
                hd: BrowserStyle.borderLeft(BrowserStyle.px(1), "solid", {
                      TAG: /* Grey */2,
                      _0: /* Dark */1
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  highlightKeyframes: highlightKeyframes,
  progressContainer: progressContainer,
  progressWrapper: progressWrapper,
  cancelContainer: cancelContainer
};

function WebComponents_ProgressHeader$StepButton(Props) {
  var activeStatus = Props.activeStatus;
  var shiftStep = Props.shiftStep;
  var setActiveStep = Props.setActiveStep;
  var stepIsAvailable = Props.stepIsAvailable;
  return React.createElement(BrowserComponents_Button.Base.make, {
              children: React.createElement(BrowserComponents_Icon.make, {
                    color: activeStatus !== 0 ? ({
                          TAG: /* White */7,
                          _0: /* Light */2
                        }) : ({
                          TAG: /* Grey */2,
                          _0: /* Dark */1
                        }),
                    icon: {
                      TAG: /* Small */1,
                      _0: WebTypes_PostAShift_Step.toIcon(shiftStep)
                    }
                  }),
              className: progressContainer(activeStatus),
              disabled: !stepIsAvailable,
              onClick: (function (param) {
                  if (stepIsAvailable) {
                    return Curry._1(setActiveStep, shiftStep);
                  } else {
                    return Relude_IO.pure(undefined);
                  }
                }),
              key: WebTypes_PostAShift_Step.toString(shiftStep)
            });
}

var StepButton = {
  make: WebComponents_ProgressHeader$StepButton
};

function WebComponents_ProgressHeader(Props) {
  var activeStep = Props.activeStep;
  var availableShiftSteps = Props.availableShiftSteps;
  var onCancel = Props.onCancel;
  var setActiveStep = Props.setActiveStep;
  return React.createElement(WebComponents_Header.Desktop.make, {
              children: null,
              className: container,
              onLogoClick: Relude_IO.pure(undefined)
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: progressWrapper,
                  children: React.createElement(ReactUtils.L.make, {
                        children: Relude_List.map(function (shiftStep) {
                                return React.createElement(WebComponents_ProgressHeader$StepButton, {
                                            activeStatus: WebTypes_PostAShift_Step.getStepStatus(activeStep, shiftStep),
                                            shiftStep: shiftStep,
                                            setActiveStep: setActiveStep,
                                            stepIsAvailable: Curry._2(WebTypes_PostAShift_Step.$$Set.contains, shiftStep, availableShiftSteps)
                                          });
                              })(WebTypes_PostAShift_Step.list)
                      })
                }), React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_Icon.make, {
                        color: {
                          TAG: /* White */7,
                          _0: /* Light */2
                        },
                        icon: {
                          TAG: /* Small */1,
                          _0: {
                            TAG: /* Button */1,
                            _0: /* X */14
                          }
                        },
                        size: /* Large */3
                      }),
                  className: cancelContainer,
                  onClick: (function (param) {
                      return onCancel;
                    })
                }));
}

function WebComponents_ProgressHeader$Plain(Props) {
  var onCancel = Props.onCancel;
  return React.createElement(WebComponents_Header.Desktop.make, {
              children: null,
              className: container,
              onLogoClick: Relude_IO.pure(undefined)
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: progressWrapper,
                  children: React.createElement(ReactUtils.L.make, {
                        children: Relude_List.map(function (shiftStep) {
                                return React.createElement("div", {
                                            key: WebTypes_PostAShift_Step.toString(shiftStep)
                                          }, React.createElement("div", undefined));
                              })(WebTypes_PostAShift_Step.list)
                      })
                }), React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_Icon.make, {
                        color: {
                          TAG: /* White */7,
                          _0: /* Light */2
                        },
                        icon: {
                          TAG: /* Small */1,
                          _0: {
                            TAG: /* Button */1,
                            _0: /* X */14
                          }
                        },
                        size: /* Large */3
                      }),
                  className: cancelContainer,
                  onClick: (function (param) {
                      return onCancel;
                    })
                }));
}

var Plain = {
  make: WebComponents_ProgressHeader$Plain
};

var make = WebComponents_ProgressHeader;

exports.Styles = Styles;
exports.StepButton = StepButton;
exports.make = make;
exports.Plain = Plain;
/* container Not a pure module */
